// Renamed from GiftLandingPage-Practical.js
import React from 'react';
import GiftLandingPagePractical from './GiftLandingPage-Practical';

const PracticalSleepGift = () => {
  return <GiftLandingPagePractical />;
};

export default PracticalSleepGift;
